import { render, staticRenderFns } from "./Province.vue?vue&type=template&id=60438368&scoped=true"
import script from "./Province.vue?vue&type=script&lang=js"
export * from "./Province.vue?vue&type=script&lang=js"
import style0 from "./Province.vue?vue&type=style&index=0&id=60438368&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60438368",
  null
  
)

export default component.exports